import ZMessage from './message.vue'
import ZMessageNotice from './notice.vue'

const Message = {}

Message.install = function (Vue) {
  const MessageConstructor = Vue.extend(ZMessage)
  const instance = new MessageConstructor()
  const NoticeConstructor = Vue.extend(ZMessageNotice)

  const messageDom = instance.$mount().$el

  document.body.appendChild(messageDom)

  const message = (type, options) => {
    const nInstance = new NoticeConstructor()
    const noticeDom = nInstance.$mount().$el
    messageDom.appendChild(noticeDom)

    if (options === undefined) {
      if (type === 'loading') {
        nInstance.duration = 0
        nInstance.content = '加载中...'
      }
    } else if (typeof options === 'string') {
      nInstance.content = options
      if (type === 'loading') {
        nInstance.duration = 0
      }
    } else {
      if (type === 'loading' && !(options.duration >= 0)) {
        options.duration = 0
      }

      Object.keys(options).forEach((key) => {
        nInstance[key] = options[key]
      })
    }

    nInstance.type = type
    nInstance.open()

    const close = () => {
      nInstance.close()
      setTimeout(() => {
        if ('remove' in noticeDom) {
          noticeDom.remove(0)
        } else {
          noticeDom.parentNode.removeChild(noticeDom)
        }
      }, 300)
    }

    if (nInstance.duration > 0) {
      setTimeout(close, nInstance.duration)
    }

    return close
  }

  const types = ['info', 'warn', 'success', 'error', 'loading']

  Vue.prototype.$message = {}

  types.forEach((type) => {
    Vue.prototype.$message[type] = (options) => message(type, options)
  })
}

export default Message
